import MPaymentRadio from './index.vue';

MPaymentRadio.install = app => {
  app.component(MPaymentRadio.name, MPaymentRadio);
};

export default MPaymentRadio;
